import type { FinishSelectionData } from '@jouzen/ecom-components';
import { IN_STOCK, RingFinishEnum } from '@jouzen/ecom-components';
import type { MessageKey } from 'types/LocaleMessageKey';

import { getPriceAndDiscount } from '@/app/[locale]/product/_components/HardwarePDP/_utils/getPriceAndDiscount';
import type { ListProduct } from '@/queries/Products';

const OR4_HANDLE_PARTIAL = 'or4';

export const getRingFinishesData = (
  productData: ListProduct[] | undefined,
  t: (str: MessageKey) => string,
): FinishSelectionData[] => {
  const baseData: FinishSelectionData[] = [
    {
      id: RingFinishEnum.Silver,
      finish: t('product_catalog_color_silver'),
    },
    {
      id: RingFinishEnum.Black,
      finish: t('product_catalog_color_black'),
    },
    {
      id: RingFinishEnum.Stealth,
      finish: t('product_catalog_color_stealth'),
    },
    {
      id: RingFinishEnum.BrushedSilver,
      finish: t('product_catalog_color_brushed_silver'),
    },
    {
      id: RingFinishEnum.Gold,
      finish: t('product_catalog_color_gold'),
    },
    {
      id: RingFinishEnum.RoseGold,
      finish: t('product_catalog_color_rosegold'),
    },
  ];

  const ringsData: ListProduct[] | undefined = productData?.filter(
    (product: ListProduct) => product.isRing,
  );
  const oR4RingsData = ringsData?.filter((product: ListProduct) =>
    product.handle.includes(OR4_HANDLE_PARTIAL),
  );

  oR4RingsData?.forEach((product) => {
    const finish = product.handle
      .split(`${OR4_HANDLE_PARTIAL}-`)
      .join('') as RingFinishEnum;
    const basefinishes = baseData.map((data) => data.id);

    if (basefinishes.includes(finish)) {
      const index = baseData.findIndex((data) => data.id === finish);
      const { discountPrice: discount, price } = getPriceAndDiscount(product);

      if (index !== -1 && baseData[index]) {
        baseData[index] = {
          ...baseData[index],
          price: price!,
          discount,
          stockStatus: IN_STOCK, // @TODO: Implement stock status logic from size later variant
        };
      }
    }
  });

  return baseData;
};
